import React from 'react';
import WarningActionDialog from './WarningActionDialog';
import { displayInfo } from '../EcwConstants';

interface OrderValuesConfirmationDialogProps {
    show: boolean;
    routeLabel?: string;
    siteLabel?: string;
    qty?: number | string;
    unit?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const OrderValuesConfirmationDialog: React.FC<OrderValuesConfirmationDialogProps> = ({
    show,
    routeLabel,
    siteLabel,
    qty,
    unit,
    onConfirm,
    onCancel,
}) => {
    const formattedQty = () => {
        const qtyText = displayInfo(qty);
        if (qtyText === "-") return "-";
        return unit?.trim() ? `${qtyText} (${unit.trim()})` : qtyText;
    };

    return (
        <WarningActionDialog
            id="OrderValuesConfirmationModal"
            show={show}
            title="Warning"
            message="Please confirm the following details for this order before proceeding:"
            acceptText="Confirm"
            cancelText="Cancel"
            onAccept={onConfirm}
            onCancel={onCancel}
        >
            <ul className="order-details-list">
                <li>Route : <strong>{displayInfo(routeLabel)}</strong></li>
                <li>Site : <strong>{displayInfo(siteLabel)}</strong></li>
                <li>Quantity : <strong>{formattedQty()}</strong></li>
            </ul>
            <p className="order-confirmation-note">Once you continue, these details cannot be changed. Please review them before proceeding.</p>
        </WarningActionDialog>
    );
};

export default OrderValuesConfirmationDialog;
